import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from 'antd';

import { useNavigate, useParams } from 'react-router-dom';
import { DropdownMobile, errorCatch, GET, JSXMap, updateInArray, useAuth, useTranslateContext } from 'fennec-ui';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { PrinterOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { getIndexColor, getIndexColorAlt, getIndexColorLighter } from '../../../../common/Tool';
import dayjs from 'dayjs';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../common/Context';
import { Collapse } from 'antd-mobile';

const User = ({ user }) => {
	return (<div style={{
		border: "1px solid transparent",
		maxWidth: "208px",
		minWidth: "208px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		justifyContent: "flex-start",
		gap: "5px",
		alignItems: "center"
	}}>
		<div style={{ backgroundColor: (user?.genderID === 1) ? "blue" : "red", width: "13px", height: "13px", lineHeight: "13px", borderRadius: "3px", textAlign: "center" }}>
			<Icofont icon='user' style={{ color: "white", fontSize: "8px", marginLeft: "1px" }} />
		</div>
		<div>{user?.lastname} {user?.firstname}</div>
	</div>)
}
const UserDoubleLine = ({ user }) => {
	return (<div className='bg bg-grey' style={{
		textAlign: "left",
		border: "1px solid transparent",
		height: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		justifyContent: "flex-start",
		gap: "5px",
		alignItems: "center"
	}}>
		<div style={{ flex: "0 0 14px", backgroundColor: (user?.genderID === 1) ? "blue" : "red", height: "100%", lineHeight: "14px", borderRadius: "3px", textAlign: "center" }}>
			<Icofont icon='user' style={{ color: "white", fontSize: "8px", marginLeft: "1px" }} />
		</div>
		<div style={{ flex: "1 1 auto" }}>
			<div>{user?.lastname}</div>
			<div>{user?.firstname}</div>
		</div>
	</div>)
}

{/* <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 484.21 484.21"><g>	<path d="M395.527,97.043V55.352H124.537l159.46,171.507c9.983,10.749,9.848,27.458-0.319,38.026L126.017,428.861h269.504v-25.18		c0-15.256,12.413-27.668,27.674-27.668c15.256,0,27.681,12.412,27.681,27.668v52.848c0,15.262-12.419,27.681-27.681,27.681H61.014		c-11.106,0-21.107-6.603-25.464-16.834c-4.359-10.226-2.189-22.012,5.509-30.026l184.584-191.964L40.743,46.521		c-7.492-8.068-9.496-19.798-5.101-29.899C40.042,6.525,50.005,0,61.014,0h362.188c15.255,0,27.68,12.413,27.68,27.68v69.363		c0,15.259-12.419,27.677-27.68,27.677C407.94,124.72,395.527,112.308,395.527,97.043z"/></g></svg> */}
{/* <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 475.636 475.636"><g><path d="M200.811,400.719V355.39h107.377v22.353l14.315-14.89l7.176-7.463l6.845-7.119l-6.694-7.201h-7.326v-7.88l-14.315-15.398 v23.278H200.811v-47.011h85.319l-13.308-14.313h-72.012v-49.632h58.695c4.557-7.294,11.845-12.373,20.147-14.315h-78.836v-53.686 h107.378v52.755h14.312v-52.755h110.148v52.755h14.312V32.873c0-9.208-7.49-16.698-16.692-16.698H16.697 C7.485,16.175,0,23.671,0,32.873v365.861c0,5.646,2.839,10.637,7.155,13.663v2.633h5.988c1.149,0.253,2.331,0.398,3.554,0.398 h255.252l14.148-14.709H200.811z M322.503,30.495h107.759c1.316,0,2.395,1.072,2.395,2.389v48.121H322.503V30.495z M322.503,95.316 h110.153v52.494H322.503V95.316z M200.811,30.495h107.377v50.509H200.811V30.495z M200.811,95.316h107.377v52.494H200.811V95.316z M66.005,400.719H15.458c-0.673-0.415-1.149-1.13-1.149-1.985V355.39h51.697V400.719z M66.005,341.069H14.309v-47.004h51.697 		V341.069z M66.005,279.755H14.309v-49.628h51.697V279.755z M66.005,215.81H14.309v-53.686h51.697V215.81z M66.005,147.81H14.309 		V95.316h51.697V147.81z M186.493,400.719H80.318V355.39h106.175V400.719z M186.493,341.069H80.318v-47.004h106.175V341.069z 		 M186.493,279.755H80.318v-49.628h106.175V279.755z M186.493,215.81H80.318v-53.686h106.175V215.81z M186.493,147.81H80.318V95.316 		h106.175V147.81z M186.493,80.999H80.318v-50.51h106.175V80.999z M449.929,279.574v-19.376H324.007l74.103,79.69 		c4.637,4.988,4.562,12.748-0.141,17.664l-73.271,76.201h125.231v-11.697c0-7.094,5.757-12.862,12.849-12.862 		s12.858,5.769,12.858,12.862v24.556c0,7.087-5.767,12.849-12.858,12.849h-168.28c-5.155,0-9.806-3.062-11.823-7.814 		c-2.021-4.755-1.031-10.231,2.56-13.953l85.753-89.193l-85.907-92.399c-3.479-3.743-4.408-9.198-2.363-13.895 		c2.046-4.688,6.659-7.721,11.781-7.721h168.28c7.092,0,12.858,5.768,12.858,12.854v32.23c0,7.097-5.767,12.858-12.858,12.858 		S449.929,286.666,449.929,279.574z" /></g></svg> */}

export default function EffektivnostSudeiEvent(props) {
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	let navigate = useNavigate();

	const { auth } = props;
	const { eventid } = useParams();
	const t = useTranslateContext();
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState()
	// "meropriyatie"
	// "tourList"
	// "esItogPoMeropriyatiyu"
	// "esItogPoTuru"

	useEffect(() => {
		setLoading(true);

		GET(auth, `/api/report/effektivnost-sudei-po-meropriyatiyu/${eventid}`, ({ data }) => {
			setData(data)
			setLoading(false);
		}, (err) => errorCatch(err, () => setLoading(false)));

	}, [auth]);

	const ref = useRef(null)

	const buildLegend = (data) => {
		let a = {}
		for (let i = 0; i < data?.tourList?.length; i++) {
			const tour = data?.tourList[i];
			let color = getIndexColorLighter(tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID || 1, 0.25)
			a[tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID] = {
				ID: tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID,
				active: true,
				color,
				tantsevalnayaDistsiplina: tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie,
				kategoriyaUchastnikov: tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie,
			}
		}
		return a
	}
	const [legend, setLegend] = useState()
	useEffect(() => {
		if (data) {
			setLegend(buildLegend(data))
		}
	}, [data])
	const triggerLegend = (item) => {
		setLegend(o => {
			let a = { ...o };
			a[item?.ID] = { ...item, active: !item.active }
			return a;
		})
	}
	if (isDesktopOrLaptop || !isMobile) {
		// console.log("desktop");
		return (
			<div>
				<div style={{ display: "flex", justifyContent: "right", padding: "15px 20px" }} >
					{/* {(data?.meropriyatie?.ID) && <Button onClick={(e) => {
						navigate(`/app/federation-administrator/events/${data?.meropriyatie?.ID}`);
					}}>Назад</Button>} */}
					<ReactToPrint
						trigger={() => {
							// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
							// to the root node of the returned component as it will be overwritten.
							return (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /> Печать</Button>)
						}}
						content={() => ref.current}
					/>
				</div>
				{(data?.tourList) && <div className="report" style={{ padding: "0 25px" }} ref={ref}>
					{(data?.meropriyatie) && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "16px", marginBottom: "20px" }}>
						<div>
							<span>{data?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(data?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ({data?.meropriyatie?.mestoProvedeniya?.name})
						</div>
					</div>}
					<div className='scrollable' style={{ backgroundColor: "white" }}>
						<table className="table" style={{ fontSize: "13px" }}>
							<thead>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
										<div className='bg bg-grey dark-1'>Судья</div>
									</th>
									<th className="wrap fixed" style={{ left: "210px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
										<div className='bg bg-grey dark-3 border-grey' style={{ fontWeight: "bold" }}>Количество судейств в турах</div>
									</th>
									<th className="wrap fixed" style={{ left: "310px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-5 border-orange' style={{ fontWeight: "bold" }}>Среднее</div>
									</th>
									{JSXMap(data?.tourList, (tour, cidx) => {
										let color = getIndexColorLighter(tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID || 1, 0.25)
										return (<th className="wrap" style={{ fontWeight: "300" }} key={cidx}>
											<div className="bg pointer" onClick={(e) => {
												navigate(`/app/reports/effektivnost-sudei/tour/${tour?.ID}`);
											}} style={{ backgroundColor: color }}>
												<span>{tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie}, </span>
												<span>{tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie}, </span>
												<span>Тур №{tour?.number} ({tour?.tourType?.name})</span>
											</div>
										</th>)
									})}
								</tr>
							</thead>
							<tbody style={{ fontSize: "12px" }}>
								{JSXMap(data?.esItogPoMeropriyatiyu || [], (judgeItem, cidx) => {

									return (<tr key={cidx}>
										<td className={`fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
											<User user={judgeItem?.sudya?.user} />
										</td>
										<td className={`fixed`} style={{ left: "210px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
											<div className="fixed bg bg-grey light-3" style={{ fontWeight: "bold" }}>
												{(judgeItem?.srednee) ? judgeItem?.kolichestvoSudeistvVTurakh : ""}
											</div>
										</td>
										<td className={`fixed`} style={{ left: "310px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
											<div className="fixed bg bg-orange dark-1" style={{ fontWeight: "bold" }}>
												{(judgeItem?.srednee) ? judgeItem?.srednee : ""}
											</div>
										</td>
										{JSXMap(data?.tourList, (tour, cidx) => {
											let itemCell = data?.esItogPoTuru?.find((el) => {
												return el?.sudya?.judgeEvent?.eventUserID == judgeItem?.sudyaID &&
													el?.sudya?.tourID == tour?.ID
											})
											let color = getIndexColorLighter(tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID || 1, 0.14)
											return (<td className="wrap" style={{ fontWeight: "300" }} key={cidx}>
												<div className="bg bg-grey" style={{ backgroundColor: color }}>
													{(itemCell?.srednee) ? itemCell?.srednee : ""}
												</div>
											</td>)
										})}
									</tr>)
								})}
							</tbody>
						</table>
					</div>
				</div>}
			</div >);
	} else {
		// console.log("mobile"); 
		return (
			<div>
				<div style={{ display: "flex", justifyContent: ((data?.meropriyatie?.ID) ? "space-between" : "right"), padding: "15px 10px" }} >
					{(data?.meropriyatie?.ID) && <Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }} onClick={(e) => {
						// navigate(`/app/federation-administrator/events/${data?.meropriyatie?.ID}`);
						navigate(-1);
					}}><i className='fa fa-chevron-left'></i></Button>}
					<ReactToPrint trigger={() => (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /></Button>)} content={() => ref.current} />
				</div>
				{(data?.tourList) && <div className="report" style={{ padding: "0 5px" }} ref={ref}>
					{(data?.meropriyatie) && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "16px", marginBottom: "20px", textAlign: "center" }}>
						<div>
							<span>{data?.meropriyatie?.nazvanieMeropriyatiya}</span>
						</div>
						<div>
							{dayjs(data?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")}
						</div>
						<div>
							({data?.meropriyatie?.mestoProvedeniya?.name})
						</div>
					</div>}
					<div>
						<Collapse>
							<Collapse.Panel key='1' title={<span style={{ fontSize: "14px" }}><i className="fa fa-question-circle-o"></i> Описание</span>}>
								{JSXMap(Object.values(legend || {}), (e, idx) => (
									<div key={idx} onClick={() => triggerLegend(e)} style={{ display: "flex", gap: "5px", paddingBottom: "5px", fontSize: "12px", color: "rgba(0,0,0,.85)" }}>
										<div style={{ flex: "0 0 20px", backgroundColor: e.color, height: "20px", borderRadius: "4px", border: "1px solid #e1e1e1", textAlign: "center" }}>
											{!!e?.active && <i className="fa fa-check"></i>}
										</div>
										<div style={{ flex: "1 1 auto" }}>
											- {e?.tantsevalnayaDistsiplina}, {e?.kategoriyaUchastnikov}
										</div>
									</div>
								))}
							</Collapse.Panel>
						</Collapse>
					</div>
					<div className='scrollable' style={{ backgroundColor: "white" }}>
						<table className="table" style={{ fontSize: "13px" }}>
							<thead>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "100px", backgroundColor: "white" }}>
										<div className='bg bg-grey dark-1'>Судья</div>
									</th>
									<th className="wrap fixed" style={{ left: "100px", minWidth: "55px", maxWidth: "50px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-5 border-orange' style={{ fontSize: "10px", fontWeight: "bold" }}>
											<div style={{ fontWeight: "bold" }}>Сред.</div>
											<div style={{ fontSize: "10px", fontWeight: "lighter" }}>[Кол-во]</div>
										</div>
									</th>
									{JSXMap(data?.tourList, (tour, cidx) => {
										let color = getIndexColorLighter(tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID || 1, 0.25)
										if (!legend || !legend[tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID] || !legend[tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID].active) {
											return (<React.Fragment key={cidx}></React.Fragment>)
										}
										return (<th className="wrap" style={{ fontWeight: "300", minWidth: "48px" }} key={cidx}>
											<DropdownMobile
												titles={{
													header: (<div style={{ textAlign: "center", flex: "1 1 auto" }}>
														<div>{tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie}</div>
														<div>{tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie}</div>
														<div style={{ fontSize: "12px", lineHeight: "14px" }}>Тур №{tour?.number} ({tour?.tourType?.name})</div>
													</div>),
												}}
												items={() => [{
													auth,
													readonly: false,
													title: (<div style={{ display: "flex", gap: "5px" }}>
														<div><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 446.969 446.969"><g><path d="M430.266,23.857H16.699C7.487,23.857,0,31.354,0,40.555v365.86c0,5.654,2.841,10.637,7.155,13.663v2.632h5.989		c1.149,0.252,2.332,0.401,3.555,0.401h413.575c1.22,0,2.401-0.149,3.545-0.401h0.821v-0.251		c7.088-1.938,12.328-8.362,12.328-16.044V40.561C446.969,31.354,439.479,23.857,430.266,23.857z M66.006,408.396H15.459		c-0.674-0.416-1.148-1.132-1.148-1.98v-43.35h51.695V408.396z M66.006,348.751H14.311v-47.01h51.695V348.751z M66.006,287.432		H14.311V237.8h51.695V287.432z M66.006,223.487H14.311V169.8h51.695V223.487z M66.006,155.486H14.311v-52.493h51.695V155.486z		 M186.495,408.396H80.318v-45.33h106.176V408.396z M186.495,348.751H80.318v-47.01h106.176V348.751z M186.495,287.432H80.318V237.8		h106.176V287.432z M186.495,223.487H80.318V169.8h106.176V223.487z M186.495,155.486H80.318v-52.493h106.176V155.486z		 M186.495,88.676H80.318v-50.51h106.176V88.676z M308.19,408.396H200.812v-45.33H308.19V408.396z M308.19,348.751H200.812v-47.01		H308.19V348.751z M308.19,287.432H200.812V237.8H308.19V287.432z M308.19,223.487H200.812V169.8H308.19V223.487z M308.19,155.486		H200.812v-52.493H308.19V155.486z M308.19,88.676H200.812v-50.51H308.19V88.676z M432.656,406.416c0,0.845-0.477,1.56-1.148,1.98		H322.503v-45.33h110.153V406.416z M432.656,348.751H322.503v-47.01h110.153V348.751z M432.656,287.432H322.503V237.8h110.153		V287.432z M432.656,223.487H322.503V169.8h110.153V223.487z M432.656,155.486H322.503v-52.493h110.153V155.486z M432.656,88.676		H322.503v-50.51h107.763c1.312,0,2.391,1.073,2.391,2.389V88.676z M297.261,142.238h-85.921v-29.883h85.917v29.883H297.261z		 M297.261,209.757h-85.921v-29.882h85.917v29.882H297.261z M297.261,275.125h-85.921v-29.883h85.917v29.883H297.261z		 M297.261,339.843h-85.921v-29.878h85.917v29.878H297.261z M297.261,399.619h-85.921v-29.888h85.917v29.888H297.261z" /></g></svg></div>
														<div><span>Посмотреть таблицу по туру</span></div>
													</div>),
													action: (values, unlock, close) => navigate(`/app/reports/effektivnost-sudei/tour/${tour?.ID}`),
												}]}
												trigger={(click) => (<div className="bg pointer" onClick={click} style={{ backgroundColor: color }}>
													<div style={{ fontSize: "10px", lineHeight: "14px" }}>Тур {tour?.number}</div>
													<div style={{ fontSize: "10px", lineHeight: "14px" }}>({tour?.tourType?.name?.slice(0, 3)}.)</div>
												</div>)}
											/>
											{/* <div className="bg pointer" onClick={(e) => {
												navigate(`/app/reports/effektivnost-sudei/tour/${tour?.ID}`);
											}} style={{ backgroundColor: color }}>
												<div style={{ fontSize: "10px", lineHeight: "14px" }}>Тур {tour?.number}</div>
												<div style={{ fontSize: "10px", lineHeight: "14px" }}>({tour?.tourType?.name?.slice(0, 3)}.)</div>
											</div> */}
										</th>)
									})}
								</tr>
							</thead>
							<tbody style={{ fontSize: "12px" }}>
								{JSXMap(data?.esItogPoMeropriyatiyu || [], (judgeItem, cidx) => {

									return (<tr key={cidx}>
										<td className={`fixed`} style={{ minWidth: "100px", backgroundColor: "white", height: "40px" }}>
											<UserDoubleLine user={judgeItem?.sudya?.user} />
										</td>
										<td className={`fixed`} style={{ left: "100px", minWidth: "55px", maxWidth: "50px", backgroundColor: "white", height: "40px" }}>
											<div className="fixed bg bg-orange dark-1" style={{ height: "100%", lineHeight: "16px" }}>
												<div style={{ fontWeight: "bold" }}>{(judgeItem?.srednee) ? judgeItem?.srednee : ""}</div>
												<div style={{ fontSize: "10px", fontWeight: "lighter" }}>{(judgeItem?.srednee) ? "[" + judgeItem?.kolichestvoSudeistvVTurakh + "]" : ""}</div>
											</div>
										</td>
										{JSXMap(data?.tourList, (tour, cidx) => {
											let itemCell = data?.esItogPoTuru?.find((el) => {
												return el?.sudya?.judgeEvent?.eventUserID == judgeItem?.sudyaID &&
													el?.sudya?.tourID == tour?.ID
											})
											let color = getIndexColorLighter(tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID || 1, 0.14)
											if (!legend || !legend[tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID] || !legend[tour?.kategoriiUchastnikovNaMeropriyatiyakh?.ID].active) {
												return (<React.Fragment key={cidx}></React.Fragment>)
											}
											return (<td className="wrap" style={{ fontWeight: "300", minWidth: "48px", height: "40px" }} key={cidx}>
												<div className="bg bg-grey" style={{ backgroundColor: color, height: "100%" }}>
													{(itemCell?.srednee) ? itemCell?.srednee : ""}
												</div>
											</td>)
										})}
									</tr>)
								})}
							</tbody>
						</table>
					</div>
				</div>}
			</div >);
	}
}
